export const PASSWORD_REGEX =
  /(?=.{10})(?=.*[a-z]{1,})(?=.*[A-Z]{1,})(?=.*[0-9]{1,})(?=.*[[#?!@£$%^&*(){}_+=<>:;"'|~`,./\-\]]{1,})/;
